<template>
  <div class="layer-tem">
    <!-- 关闭按钮 -->
    <img
      :src="newClose"
      class="close-btn"
      alt=""
      @click="closeLayer"
    >
    <!-- 主内容 -->
    <div class="layer-main">
      <!-- 导航 -->
      <tab-nav
        :tabArr="tabArr"
        :parNavIndex="tabIndex"
        @index="tabIndexFn"
      ></tab-nav>
      <!-- 块 -->
      <div class="block-list">
        <div class="block-head">
          <!-- 标题 -->
          <div class="tit">
            风险指数排名
          </div>
          <!-- 下拉框 -->
          <div class="select-wrap">
            <Select
              v-model="areaId"
              transfer
              :word-wrap="true"
              clearable
              style="width: 100px;margin-right: 10px;"
              placeholder="区域"
              @on-change="formChange"
              v-show="tabIndex == 1"
            >
              <Option
                v-for="item in areaArr"
                :value="item.sid"
                :key="item.id"
              >
                {{ item.name }}
              </Option>
            </Select>
            <Select
              v-model="industId"
              transfer
              :word-wrap="true"
              clearable
              style="width: 100px;"
              placeholder="行业"
              @on-change="formChange"
              v-show="tabIndex == 0"
            >
              <Option
                v-for="item in industArr"
                :value="item.value"
                :key="item.id"
              >
                {{ item.name }}
              </Option>
            </Select>
          </div>
        </div>
        <div class="block-main">
          <!-- 列表 滚动加载更多 -->
          <div class="block-main-content">
            <!-- 周月导航 -->
            <!-- echart图 -->
            <ul class="time_nav_bar">
              <li
                v-for="(item, index) in timeArr"
                :key="index"
                :class="{'active': index == timeIndex}"
                @click="timeNav(index)"
              >
                {{item}}
              </li>
            </ul>
            <div
              class="echart"
              ref="echart"
              v-show="echartArr.length"
            ></div>
            <p
              class="no-data"
              v-show="!echartArr.length && getEchartStatus"
            >
              暂无数据
            </p>
          </div>
        </div>
      </div>
      <!-- 块 -->
      <div class="block-list">
        <div class="block-head">
          <!-- 标题 -->
          <div class="tit">
            {{tableTit}}安全指数排名
          </div>
        </div>
        <div class="block-main">
          <!-- 列表 滚动加载更多 -->
          <div class="block-main-content">
            <!-- 列表 滚动加载更多 -->
            <!-- 列表 滚动加载更多 -->
            <div class="table-wrap">
              <div class="table-head">
                <table>
                  <tr>
                    <th width="5%">
                      序号
                    </th>
                    <th width="25%">
                      单位名称
                    </th>
                    <th width="25%">
                      单位地址
                    </th>
                    <th width="10%">
                      责任人
                    </th>
                    <th width="15%">
                      联系方式
                    </th>
                    <th width="10%">
                      分数
                    </th>
                    <th width="10%">
                      详情
                    </th>
                  </tr>
                </table>
              </div>
              <div
                class="table-body"
                id="midTop"
              >
                <table>
                  <tr
                    v-for="(item, index) in tableListArr"
                    :key="index"
                  >
                    <td width="5%">
                      {{index+1}}
                    </td>
                    <td width="25%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.name"
                        v-if="item.name"
                      >
                        {{item.name}}
                      </Poptip>
                    </td>
                    <td width="25%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.address"
                        v-if="item.address"
                      >
                        {{item.address}}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.leader"
                        v-if="item.leader"
                      >
                        {{item.leader}}
                      </Poptip>
                    </td>
                    <td width="15%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.leaderPhone"
                        v-if="item.leaderPhone"
                      >
                        {{item.leaderPhone}}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <Poptip
                        trigger="hover"
                        transfer
                        :word-wrap="true"
                        :content="item.score"
                        v-if="item.score"
                      >
                        {{item.score}}
                      </Poptip>
                    </td>
                    <td width="10%">
                      <span
                        class="viewDetail"
                        @click="showDetailLayer(item.orgId,item)"
                      >查看</span>
                    </td>
                  </tr>
                </table>
                <p
                  class="no-data"
                  v-show="(!tableListArr.length && getTableStatus) || (!echartArr.length)"
                >
                  暂无数据
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import close from "@/assets/img/close.png";
import newClose from "@/assets/img/newClose.png";
import tabNav from "./tab-nav.vue";
import tableTem from "./layer-table.vue";

import { themeArr } from "@/assets/js/theme.js";
export default {
  name: "",
  data: () => ({
    echarts_color: themeArr[0].color,
    close,
    newClose,
    tabArr: ["区域", "行业", "单位"],
    tabIndex: 0,
    // timeArr: ['周', '月'],
    timeArr: ["昨日", "上周", "上月"],
    timeIndex: 0,
    hashValue: "",
    loginData: {},
    professList: [],
    industArr: [],
    industId: "",
    areaArr: [],
    areaId: "",
    professId: "",
    echartDom: null,
    echartArr: [],
    getEchartStatus: false,
    getTableStatus: false,
    top_echart: null,
    tableTit: "",
    tableListArr: [],
    tableDepId: "",
    currentPage: 1,
    totalCount: "",
  }),
  components: {
    tabNav,
    tableTem,
  },
  created() {
    this.hashValue = localStorage.getItem("hashValue");
    this.loginData = JSON.parse(localStorage.getItem("loginData"));
    this.getAreaData();
    this.getIndustData();
  },
  mounted() {
    this.getEchartData();
  },
  computed: {},
  methods: {
    showDetailLayer(id, item) {
      //显示详情弹窗
      this.$store.commit("baseInfoLayer", {
        detailStatus: true,
        baseInfoId: id,
        baseInfoItem: item,
      });
    },
    getAreaData() {
      let dataObj = {
        type: "get",
        url: "/mcbw/areas/" + this.loginData.orgId,
        obj: {},
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("区域数据");
        if (res.data.success && res.data.data.length) {
          this.areaArr = res.data.data;
        }
      });
    },
    getIndustData() {
      let dataObj = {
        type: "get",
        url: "/mcbw/dictionary_datas/industryCategory/data",
        obj: {},
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("行业数据");
        if (res.data.success && res.data.data.length) {
          this.industArr = res.data.data;
        }
      });
    },
    closeLayer() {
      this.$store.commit("showLayer", {
        status: false,
        type: "",
      });
    },
    tabIndexFn(tabIndex) {
      //导航切换
      this.tabIndex = tabIndex; //0区域 1行业 2单位
      this.areaId = "";
      this.industId = "";
      this.timeIndex = 0;
      this.getEchartData();
    },
    timeNav(index) {
      this.timeIndex = index;
      this.getEchartData();
    },
    dataInit() {
      //初始化数据
    },
    formChange() {
      //行业下拉选
      this.getEchartData();
    },
    getEchartData() {
      this.getEchartStatus = false;
      this.tableTit = "";
      this.tableDepId = "";
      (this.currentPage = 1), (this.tableListArr = []);
      if (this.top_echart) {
        this.top_echart.clear();
      }
      let dataObj = {
        type: "get",
        url: "/mcbw/risk_report/safety_index",
        obj: {
          monitorId: this.loginData.orgId,
          type:
            this.tabIndex == 1
              ? "industryCategory"
              : this.tabIndex == 2
              ? "orgId"
              : "areaSid",
          dataType:
            this.timeIndex == 0
              ? "yesterday"
              : this.timeIndex == 1
              ? "lastWeek"
              : "lastMonth",
          order: "desc",
          limit: 10,
        },
      };
      if (this.tabIndex === 0) {
        //区域
        if (this.industId) {
          dataObj.obj["industryCategory"] = this.industId;
        }
      } else {
        //行业
        if (this.areaId) {
          dataObj.obj["areaSid"] = this.areaId;
        }
      }
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("图表数据");
        this.getEchartStatus = true;
        this.echartArr = Object.keys(res.data.data);
        if (res.data.success && this.echartArr.length) {
          this.$nextTick(() => {
            this.topMidInit(res.data.data);
          });
          this.parTit = res.data.data.xAxis[0];
          this.tableDepId = res.data.data.ids[0];
          this.getTableData();
        } else {
          this.no_data_status_top = true;
          return false;
        }
      });
    },
    left_name_substr(data, type) {
      let name_arr = [];
      let value_arr = [];
      for (let i = 0; i < data.series.length; i++) {
        if (data.xAxis[i] == null) {
          name_arr.push("空");
        } else {
          if (data.xAxis[i].length > 4) {
            name_arr.push(data.xAxis[i].substr(0, 4) + "...");
          } else {
            name_arr.push(data.xAxis[i]);
          }
        }
        value_arr.push({
          value: data.series[i],
          id: data.ids[i],
          name: data.xAxis[i],
        }); //自定义数据
      }
      if (type == "name") {
        return name_arr;
        //这里进行一下字数限制，如果大于4个字，就省略号显示
      } else {
        return value_arr;
      }
    },
    topMidInit(data, dom) {
      //左上图
      let that = this;
      let res = data;
      let option = {
        tooltip: {
          trigger: "axis",
          formatter: function (params) {
            // console.log(params[0]);
            let res = `<div>${data.xAxis[params[0].dataIndex]}</div>`;
            res += `<p><span style="display:inline-block;margin-right: 5px;width: 10px;height: 10px;border-radius: 10px;background: ${params[0].color.colorStops[0].color}"></span>安全指数: ${params[0].value}</p>`;
            return res;
          },
          textStyle: {
            color: that.echarts_color,
          },
          confine: true,
        },
        calculable: true,
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: that.left_name_substr(res, "name"),
            axisLine: {
              show: true,
              lineStyle: {
                color: "#122856",
              },
            },
            axisLabel: {
              textStyle: {
                color: that.echarts_color,
              },
              interval: 0,
              // rotate:40,
              fontSize: 10,
            },
          },
        ],
        yAxis: [
          {
            minInterval: 1,
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "transparent",
              },
            },
            max: 100,
            min: 0,
            axisLabel: {
              textStyle: {
                color: that.echarts_color,
              },
            },
            splitLine: {
              lineStyle: {
                color: "#122856",
              },
            },
          },
        ],
        series: [
          {
            name: "安全指数",
            type: "bar",
            data: that.left_name_substr(res, "value"),
            barWidth: 30,
            itemStyle: {
              normal: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#fd6760", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#fd6760", // 100% 处的颜色
                    },
                  ],
                  globalCoord: false, // 缺省为 false
                },
              },
            },
          },
        ],
      };
      this.topOption = option;
      this.top_echart = this.$echarts.init(this.$refs.echart);
      this.top_echart.setOption(option);
      this.top_echart.off("click");
      this.top_echart.on("click", function (params) {
        that.tableTit = params.data.name;
        that.tableDepId = params.data.id;
        (that.currentPage = 1), (that.tableListArr = []);
        that.getTableData();
      });
    },
    getTableData() {
      console.log("数字", this.tabIndex);
      let dataObj = {
        type: "get",
        url: "/mcbw/risk_report/dep_safety_index",
        obj: {
          monitorId: this.loginData.orgId,
          // "type": this.tabIndex==1 ? 'industryCategory' :this.tabIndex==2 ? "orgId": "areaSid",
          type: "orgId",
          dataType:
            this.timeIndex == 0
              ? "yesterday"
              : this.timeIndex == 1
              ? "lastWeek"
              : "lastMonth",
          sort: "ASC",
          currentPage: this.currentPage,
          pageSize: 50,
          areaSid:
            this.tabIndex == 1 ? "" : this.tabIndex == 2 ? "" : this.tableDepId,
          industryCategory:
            this.tabIndex == 0 ? "" : this.tabIndex == 2 ? "" : this.tableDepId,
          orgId:
            this.tabIndex == 0 ? "" : this.tabIndex == 1 ? "" : this.tableDepId,
        },
      };
      this.$Axios(dataObj).then((res) => {
        console.log(res);
        console.log("table表格数据");
        this.getTableStatus = true;
        if (res.data.success) {
          if (res.data.totalCount) {
            this.totalCount = res.data.totalCount;
          }
          if (!res.data.data.length) {
            return;
          }
          this.tableListArr = [...this.tableListArr, ...res.data.data];
          let _this = this;
          this.$nextTick(() => {
            $JQ("#midTop").mCustomScrollbar({
              callbacks: {
                onTotalScroll: function () {
                  if (
                    _this.tableListArr.length == res.data.totalCount ||
                    res.data.data.length == 0
                  ) {
                    console.log("没有更多数据");
                    return;
                  } else {
                    console.log("加载更多");
                    _this.currentPage += 1;
                    _this.getTableData();
                  }
                },
              },
            });
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.layer-tem {
  position: absolute;
  left: 500px;
  bottom: 0;
  width: calc(100% - 1000px);
  // height: 500px;
  padding: 30px 25px;
  background: rgba(6, 18, 44, 1) url("../../assets/img/maskBg.png") center
    center/101% 102% no-repeat;
  z-index: 12;

  // 关闭按钮
  .close-btn {
    position: absolute;
    right: 0;
    top: 0;
    right: 25px;
    top: 30px;
    cursor: pointer;
  }
  .block-head {
    margin: 10px 0;
    display: flex;
    align-items: center;
    &.block-head-form {
      justify-content: space-between;
    }
    &.block-head-text {
      color: #00eef3;
      .text {
        margin-right: 20px;
      }
    }
    .tit {
      min-width: 200px;
      margin-right: 20px;
    }
  }
  .block-main {
    height: 200px;
    position: relative;
    padding: 8px;

    .block-main-content {
      height: 100%;
      position: relative;
      .time_nav_bar {
        position: absolute;
        right: 0;
        top: 5px;
        z-index: 1;
        display: flex;
        align-items: center;
        li {
          position: relative;
          padding: 0 10px;
          font-size: 14px;
          line-height: 20px;
          color: #a2d8ff;
          opacity: 0.45;
          cursor: pointer;
          &.active {
            opacity: 1;
          }
        }
      }
      .echart {
        height: 100%;
      }
      .no-data {
        height: 184px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #ddd;
      }
      .table-wrap {
        height: 100%;
        display: flex;
        flex-direction: column;
        .table-head {
          background: #0c2745;
          color: #7db4db;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          line-height: 37px;
          table th {
            height: 30px;
          }
        }
        .table-body {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
          color: #e4eff5;
          table td {
            text-align: center;
            height: 37px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #e4eff5;
            i {
              cursor: pointer;
            }
            i.imgView {
              color: rgba(8, 244, 247, 0.7);
              cursor: pointer;
              &.active {
                color: rgba(8, 244, 247, 0.3);
                cursor: default;
              }
            }
            .td-option-wrap {
              display: flex;
              align-items: center;
              justify-content: center;
              i {
                margin: 0 10px;
                color: rgba(8, 244, 247, 0.3);
                cursor: default;
                &.active {
                  color: rgba(8, 244, 247, 0.7);
                  cursor: pointer;
                }
              }
            }
          }
          table tr:nth-child(2n) {
            background: #0c2745;
          }
          .no-data {
            height: 152px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ddd;
          }
        }

        table {
          width: 100%;
          table-layout: fixed;
          border-collapse: collapse;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/layer/midTop.vue